import React, { useEffect, useState, useContext } from 'react';
import './aeh-thankyou.scss';
import Illustration from '../../../assests/svg/Illust.svg';
import Button from 'b2b-ui-components-lib/lib/components/button';
import appConfig from '../../../config/config';
import { navigateTo, removeFromSessionStorage, removeAllFromLocalStorage, removeUserSessionData } from '../../../common/utils/app.utils';
import { faOnDedicatedAehThankyouPageLoad, faOnDedicatedAehThankyouPageLoadViaSummary } from '../../services/analytics.service';
import { AUTHORIZED_SIGNATORY, MODULE_ID, SELECTED_PARTY_ACCOUNT, SELECTED_PARTY_DATA } from '../../../home/common/constants/constants';
import { getProductDisplayName, getProductType, PRODUCT_NAME, PRODUCT_TYPE } from '../../../common/constants/app.constants';
import { AppContext } from 'App';
import { redirectToTMODashboard } from 'home/view/manage-feasibility/utils/multiSite-utils';

const AehThanks = (props) => {
  let { userType, orderId, leadStatus, reason, doaStatus, via, product, isUpgrade } = props && props.location && props.location.state ? props.location.state : props;

  const [productCheck, setProductCheck] = useState('');
  const { showSteps, setToast } = useContext(AppContext);

  const toggelToastPopup = () => {
    setToast(false, '', '');
  };

  useEffect(() => {
    showSteps && showSteps(false);
    toggelToastPopup();
    const currentProduct = product || getProductType();
    setProductCheck(getProductDisplayName(currentProduct));
    removeUserSessionData();
    if (via === 'SUMMARY') {
      faOnDedicatedAehThankyouPageLoadViaSummary();
    } else {
      faOnDedicatedAehThankyouPageLoad();
    }
    // return () => {
    //   navigateTo(appConfig.aehdashboardUrl);
    // };
  }, []);

  const resetSessionData = () => {
    removeFromSessionStorage(MODULE_ID, AUTHORIZED_SIGNATORY);
    removeFromSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT);
    removeFromSessionStorage(MODULE_ID, SELECTED_PARTY_DATA);
    removeFromSessionStorage(MODULE_ID, PRODUCT_NAME);
  };

  return (
    <div className="thanksSection">
      <div className="container">
        <div className="thanks">
          <div className="thanksContent">
            <h2 className="orderCancelled">Your request has been {doaStatus === 'REJECTED' ? 'Rejected' : 'Cancelled'}</h2>
            {userType === 'KAM' ? (
              <p>
                Request number: {orderId ? orderId : ''} for {isUpgrade ? 'multiple' : 'Corporate'} {productCheck} {isUpgrade ? 'circuits upgrade' : 'Plan'}. The customised pricing
                has been rejected by the DOA. Please note that the customer cannot proceed with the order
              </p>
            ) : (
              <p>
                Request number: {orderId ? orderId : ''} for {isUpgrade ? 'multiple' : 'Corporate'} {productCheck} {isUpgrade ? 'circuits upgrade' : 'Plan'} has been{' '}
                {doaStatus === 'REJECTED' ? 'rejected' : 'cancelled'}. For any queries, write to us at <a href="airtelforbusiness@airtel.com">airtelforbusiness@airtel.com</a>.
              </p>
            )}

            {reason && (
              <p>
                <b>Reason for cancellation:</b> {reason}
              </p>
            )}
            <div className="buttonSection">
              <a href={redirectToTMODashboard()} className="track-link">
                Track Request
              </a>
              <a href={appConfig.aehdashboardUrl}>
                <Button onClick={resetSessionData}> Back to Home</Button>
              </a>
            </div>
          </div>

          <img src={Illustration} alt="Illustration" />
        </div>
      </div>
    </div>
  );
};

export default AehThanks;
